import { render, staticRenderFns } from "./NewsCategoryChangeActivationType.vue?vue&type=template&id=13dca9bd&"
import script from "./NewsCategoryChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports